import { isInstanceMatch } from './isInstanceMatch';
/**
 * Returns the {@link AuthenticationInstance} matching the given {@link AuthenticationInstanceRef}.
 */
export function getInstance(instances, instanceRef) {
    return instances.find((instance) => isInstanceMatch(instance, instanceRef));
}
